<div style="display: flex; flex-direction: column;">
    <div>
        <mat-form-field>
            <mat-label>Name</mat-label>
            <input
                #_
                matInput
                [(ngModel)]="page.label"
                type="text"
                (keyup)="page.autoLabel = _.value.length < 2"
            >
        </mat-form-field>
        @if (page.kind != 'directory') {
            <mat-form-field>
                <mat-label>File Name</mat-label>
                <input
                    #_
                    matInput
                    [(ngModel)]="page.filename"
                    type="text"
                    (keyup)="page.autoFilename = _.value.length < 2"
                >
            </mat-form-field>
        }

        <mat-form-field>
            <mat-label>Type</mat-label>
            <mat-select [(value)]="page.kind">
                @for (kind of PageKinds; track kind) {
                    <mat-option
                        [value]="kind.id"
                    >
                        {{kind.label}}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Icon</mat-label>
            <input matInput type="text" [(ngModel)]="page.icon">
        </mat-form-field>

        <app-icon-picker
            class="embedded"
            [page]="page"
            [disableAutoSave]="true"
            [iconCount]="54"
            style="width: 100%; margin-bottom: 24px;"
        />

        <mat-form-field>
            <mat-label>Color</mat-label>
            <input matNativeControl type="color" [(ngModel)]="page.color">
        </mat-form-field>

        @if (page.kind == 'code') {

            <mat-form-field>
                <mat-label>Language</mat-label>
                <mat-select [(value)]="page.options['language']">
                    @for (language of languages; track language) {
                        <mat-option
                            [value]="language"
                        >
                            {{language}}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-checkbox
                [checked]="page.options['minimap'] == null ? true : page.options['minimap']"
                (change)="page.options['minimap']=$event.checked"
            >
                Minimap
            </mat-checkbox>

            <mat-checkbox
                [checked]="page.options['folding'] == null ? true : page.options['folding']"
                (change)="page.options['folding']=$event.checked"
            >
                Folding
            </mat-checkbox>

            <mat-checkbox
                [checked]="page.options['colorDecorators'] == null ? true : page.options['colorDecorators']"
                (change)="page.options['colorDecorators']=$event.checked"
            >
                Color Decorators
            </mat-checkbox>

            <mat-form-field>
                <mat-label>Font Size</mat-label>
                <input matInput type="number" [(ngModel)]="page.options['fontSize']" [value]="16">
            </mat-form-field>

            <mat-form-field>
                <mat-label>Tab Size</mat-label>
                <input matInput type="number" [(ngModel)]="page.options['tabSize']" [value]="2">
            </mat-form-field>

        }
    </div>

    <div>
        <h5>Configuration</h5>

        <div>
            <div style="display: flex; justify-content: space-between">
                <mat-slide-toggle
                    [checked]="page.readonly"
                    (change)="page.readonly=$event.checked"
                >
                    Read Only
                </mat-slide-toggle>
            </div>
        </div>
    </div>

    <div style="flex: 1"></div>

    <div style="display: flex; gap: 10px; align-self: end">
        <button mat-flat-button color="primary" (click)="save()">Save</button>
        <button mat-flat-button color="primary" (click)="dialog.close()">Cancel</button>
    </div>
</div>
